module.exports = ".light1{\r\n    margin-left: 44px;\r\n    margin-right: 44px;\r\n    font-weight: 500;\r\n}"